const diffType = {
  equal: 'equal',
  different: 'different',
  noEqual: 'noEqual',
  noEmptyArray: 'noEmptyArray',
  noEmptyArrayPre: 'noEmptyArrayPre',
};

export default diffType;
